import {stringReplaceEmptyOrWhiteSpaceValue} from "@wix/devzai-utils-common";

export interface DoppeActionPriceData {
    actualPrice: string;
    discountPrice?: string;
}

export function doppeActionPriceDataGetActualPrice (actionPriceData: DoppeActionPriceData) {
    return stringReplaceEmptyOrWhiteSpaceValue(actionPriceData.actualPrice, undefined)
}

export function doppeActionPriceDataGetDiscountPrice (actionPriceData: DoppeActionPriceData) {
    return stringReplaceEmptyOrWhiteSpaceValue(actionPriceData.discountPrice, undefined)
}